import { mapActions, mapState, mapGetters } from 'vuex';
import filterButton from '@/components/market/market-filters/filter-button/filter-button.vue';
import menuButton from '@/components/market/market-filters/menu-button/menu-button.vue';

export default {
  components: {
    filterButton,
    menuButton,
  },
  data() {
    return {
      ordersOpen: false,
      filtersOpen: false,
      timespansOpen: false,
      isDashboardOpen: false,
      isWatchlistOpen: false,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('browse', [
      'filters',
      'orders',
      'timespans',
      'selectedFilters',
      'selectedOrder',
      'selectedTimespan',
      'shouldShowTimespanFilter',
    ]),
    mainClassName() {
      return 'market-filters';
    },
    filterMenuName() {
      const prefix = this.isLayoutMobile ? 'Keywds' : 'Keywords';
      if (this.selectedFilters && this.selectedFilters.length > 0) {
        return `${prefix} (${this.selectedFilters.length})`;
      }
      return prefix;
    },
    orderMenuName() {
      return 'Sort By';
    },
    classModifier() {
      return {
        [this.mainClassName]: true,
        [`${this.mainClassName}--is-open`]: this.filtersOpen || this.ordersOpen || this.timespansOpen,
        [`${this.mainClassName}--is-open-order`]: this.ordersOpen,
        [`${this.mainClassName}--is-open-filters`]: this.filtersOpen,
        [`${this.mainClassName}--is-open-timespans`]: this.timespansOpen,
      };
    },
    availableTimespanOptions() {
      if (this.selectedOrder && this.selectedOrder.sort === 'movers') {
        return [...this.timespans].filter(i => i.parameter !== 'ALL');
      }
      return [...this.timespans].filter(i => i.parameter !== '3DAY');
    },
  },
  methods: {
    ...mapActions('browse', [
      'addFilter',
      'removeFilter',
      'selectOrder',
      'selectTimespan',
      'clearFilters',
    ]),
    ...mapActions('overlay', {
      hideOverlay: 'hide',
      showOverlay: 'show',
    }),
    ...mapActions('dashboard', {
      dashSelectOrder: 'selectOrder',
      dashSelectTimespan: 'selectTimespan',
    }),
    ...mapActions('watchlist', {
      watchSelectOrder: 'selectOrder',
      watchSelectTimespan: 'selectTimespan',
    }),
    orderList(kind) {
      const marketsDisabledSorts = [
        'gain', 'loss', 'investment',
      ];

      return (kind === 'markets') ?
        this.orders.filter(i => !marketsDisabledSorts.includes(i.sort)) :
        this.orders;
    },
    onAddFilter(filterId) {
      this.addFilter(filterId);
      this.$emit('used');
    },
    onRemoveFilter(filterId) {
      this.removeFilter(filterId);
      this.$emit('used');
    },
    toggleFilters() {
      this.filtersOpen = !this.filtersOpen;
      this.ordersOpen = false;
      this.timespansOpen = false;
    },
    toggleOrder() {
      this.ordersOpen = !this.ordersOpen;
      this.filtersOpen = false;
      this.timespansOpen = false;
    },
    toggleTimespans() {
      this.timespansOpen = !this.timespansOpen;
      this.filtersOpen = false;
      this.ordersOpen = false;
    },
    selectOrderAndClose(sort) {
      if (this.isWatchlistOpen) {
        this.watchSelectOrder(sort);
      } else if (this.isDashboardOpen) {
        this.dashSelectOrder(sort);
      } else {
        this.selectOrder(sort);
      }
      this.toggleOrder();
      this.$emit('used');
    },
    selectTimespanAndClose(timespan) {
      if (this.isWatchlistOpen) {
        this.watchSelectTimespan(timespan);
      } else if (this.isDashboardOpen) {
        this.dashSelectTimespan(timespan);
      } else {
        this.selectTimespan(timespan);
      }
      this.toggleTimespans();
      this.$emit('used');
    },
    selectTimespanOnly(timespan) {
      this.selectTimespan(timespan);
      this.$emit('used');
    },
    filterSelected(filterId) {
      return this.selectedFilters.includes(filterId);
    },
    orderSelected(sort) {
      return this.selectedOrder.sort === sort;
    },
    closeFilters() {
      this.filtersOpen = false;
      this.ordersOpen = false;
      this.timespansOpen = false;
    },
    onClearFilters() {
      this.clearFilters();
    },
    filterKey(filter) {
      return filter.filterId.toString() + this.filterSelected(filter.filterId).toString();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-filters/market-filters-mixin/market-filters-mixin.js